export function renderMarkdown(md: string): string {
  return md
    .replace(/```(\w*)\n([\s\S]*?)```/g, '<pre class="modern-article__code"><code>$2</code></pre>')
    .replace(/^### (.+)$/gm, '<h4 class="modern-article__h4">$1</h4>')
    .replace(/^## (.+)$/gm, '<h3 class="modern-article__h3">$1</h3>')
    .replace(/^# (.+)$/gm, '<h2 class="modern-article__h2">$1</h2>')
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    .replace(/\*(.+?)\*/g, '<em>$1</em>')
    .replace(/`([^`]+)`/g, '<code class="modern-article__inline-code">$1</code>')
    .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>')
    .replace(/^\d+\. (.+)$/gm, '<li>$1</li>')
    .replace(/(<li>.*<\/li>\n?)+/g, '<ol class="modern-article__list">$&</ol>')
    .replace(/^[-*] (.+)$/gm, '<li>$1</li>')
    .replace(/(<li>.*<\/li>\n?)+/g, (match) =>
      match.includes('<ol') ? match : `<ul class="modern-article__list">${match}</ul>`)
    .replace(/^(?!<[houplc])((?!^\s*$).+)$/gm, '<p>$1</p>')
    .replace(/^---$/gm, '<hr class="modern-article__hr" />')
}

export function formatDate(dateStr: string) {
  const d = new Date(dateStr + 'T00:00:00')
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}
